export const placeholderProduct = {
  id: "placeholder",
  quantity: 0,
  name: "-",
  price: 0,
};
